<template>
<div>
  <!--<section class="hero" :style="heroBannerUrl">
  </section>-->
  <div class="hero-text">
      <h1 id="hero-title">Jonna Närhi</h1>
      <h3 id="hero-subtitle">Graphic and product designer.<br>Living and working in Salo, Finland.</h3>
  </div>  
  <About></About>
  <SayHello style="margin-top:150px"></SayHello>
</div>
</template>

<script>
// @ is an alias to /src
import { ProjectsService, LoggingService, SettingsService } from '@/services/ApiService';
import About from './About.vue';
import SayHello from './SayHello.vue';

export default {
  name: 'Home',
  components: {
    About, SayHello
},
  data () {
    return {
      projects: [],
      siteSettings: {
        bannerUrl: ""
      }
    }
  },
  created: function () {
    this.loadProjects();
    this.loadSettings();
    const root = document.documentElement;
    root.style.setProperty('--body-bg', '#ffffff');    
  },
  methods: {
    loadProjects() {
      ProjectsService.getAll().then((res) => {
        this.projects = res.data.reverse();
      }).catch((err) => {
        LoggingService.log("Home", "Error loading projects", err);
      });      
    },
    loadSettings() {
      SettingsService.get().then((res) => {
        this.siteSettings = res.data[0];
      }).catch((err) => {
        LoggingService.log("Home", "Error loading SiteSettings", err);
      });
    },
    openProjectDetail(id) {
      this.$router.push({ path: `projects/${id}` })
    }
  },
  computed: {
    heroBannerUrl: function () {
      return "background-image: url(" + this.siteSettings.bannerUrl + ")";
    }
  }
}
</script>

<style lang="less">
.card-wrapper {
  cursor: pointer;
}
.hero {
  height: 60vh;
  width: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed; 
}
.hero-text {
  margin-top: 150px;
  #hero-title {
    text-transform: capitalize;
  }
  #hero-subtitle {
    text-transform: none;
  }
  background-color: #ffffff;
  padding: 5px 30px;
  border-radius: 2px;
  color: #354537;
  h1 {
    font-size: 3em;
    margin-bottom: 0;
  }
  h2 {
    margin-bottom: 30px;
  }
}
</style>
